import { SearchResult } from 'components/Molecules/SearchCard/SearchCardModel';

export const mockSearchResults: SearchResult[] = [
  {
    id: '1',
    title: 'Despre DSU',
    url: '/despre',
    content: 'Departamentul pentru Situații de Urgență este instituția publică centrală din sistemul administrației publice naționale, sub autoritatea Guvernului...',
    image: '/images/about-dsu.jpg'
  },
  {
    id: '2',
    title: 'Planuri de acțiune',
    url: '/planuri',
    content: 'Planurile de acțiune pentru situații de urgență sunt documente fundamentale în gestionarea situațiilor de criză...',
    image: '/images/action-plans.jpg'
  },
  {
    id: '3',
    title: 'Știri și comunicate',
    url: '/noutati',
    content: 'Ultimele știri și comunicate de presă ale Departamentului pentru Situații de Urgență...'
  },
  {
    id: '4',
    title: 'Ghiduri și instrucțiuni',
    url: '/ghiduri',
    content: 'Ghiduri practice pentru populație privind modul de gestionare a situațiilor de urgență...',
    image: '/images/guides.jpg'
  },
  {
    id: '5',
    title: 'Contact',
    url: '/contact',
    content: 'Date de contact și program de lucru pentru relația cu publicul...'
  }
];

const normalize = (s = '') =>
  s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const searchInMockData = (query: string): Promise<SearchResult[]> => {
  const lowerq = normalize(query);
  return new Promise((resolve) => {
    setTimeout(() => {
      const results = mockSearchResults.filter(item => {
        return (
          normalize(item.title).includes(lowerq) ||
          normalize(item.content).includes(lowerq)
        );
      });
      resolve(results);
    }, 300);
  });
};
